import axios from 'axios';

export default {
  state: {
    user: {},
    token: localStorage.getItem('ui-t') || '',
    inc: 0
  },
  getters: {
    isLoggedIn: s => !!s.token,
    user: u => u.user,
    token: t => t.token
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      state.token = user.access_token;
    },
    logout(state) {
      state.user = {};
      state.token = '';
    }
  },
  actions: {
    async register({ commit, dispatch }, form) {
      try {
        const user = await axios.post(
          'http://api.exam.loc/v1/user/register',
          form
        );
        /**
         * Закоментировано потому что будет подтверждение по почте
         */
        // localStorage.setItem('ui-t', user.data.access_token)
        // axios.defaults.headers.common['Authorization'] = user.data.access_token
        // commit('setUser', user.data)

        console.log(user);
      } catch (e) {
        await dispatch('logout');
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async registerConfirm({commit}, token) {
      try {
        const result = await axios.get(
          `${process.env.VUE_APP_API}/user/register-confirm?t=${token}`
        );
        console.log(result.data);
        return result.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async login({ commit }, form) {
      try {
        const user = await axios.post(
          'http://api.exam.loc/v1/user/login',
          form
        );
        localStorage.setItem('ui-t', user.data.access_token);
        axios.defaults.headers.common['Authorization'] = user.data.access_token;
        commit('setUser', user.data);
        console.log(user.data);
      } catch (e) {
        commit('setError', e.response.data.message);
        // await dispatch('logout')
        throw e;
      }
    },
    async updateUser({ commit }, form) {
      try {
        const user = await axios.put(
          'http://api.exam.loc/v1/user-resourse/update',
          form
        );
        commit('setUser', user.data);
        // return true
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async userData({ commit }) {
      try {
        const userData = await axios.get('http://api.exam.loc/v1/user/index');
        commit('setUser', userData.data);
      } catch (e) {
        console.log(e.response);
        return e;
      }
    },
    async logout({ commit }) {
      console.log('lo');
      // return new Promise((resolve) => {
      commit('logout');
      commit('clearError');
      localStorage.removeItem('ui-t');
      delete axios.defaults.headers.common['Authorization'];
      //   resolve()
      // })
    },
    async userByResetPasswordToken({ commit }, token) {
      try {
        const result = await axios.get(
          `${process.env.VUE_APP_API}/user/check-reset-password?token=${token}`
        );
        console.log(result.data);
        return result.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async resetPassword({ commit }, {form, token}) {
      try {
        const result = await axios.post(
          `${process.env.VUE_APP_API}/user/reset-password?token=${token}`, form
        );
        console.log(result.data);
        return result.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async resetPasswordCancel({ commit }, token) {
      try {
        const result = await axios.get(
          `${process.env.VUE_APP_API}/user/reset-cancel?token=${token}`
        );
        return result.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async restorePassword({ commit }, form) {
      try {
        const result = await axios.post(
          `${process.env.VUE_APP_API}/user/restore-password`,
          form
        );
        console.log(result.data);
        return result.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    },
    async changePassword({ commit }, form) {
      try {
        const result = await axios.post(
          `${process.env.VUE_APP_API}/user-resourse/change-password`, form
        );
        console.log(result.data);
        if (result.data !== false) {
          localStorage.setItem('ui-t', result.data.access_token);
          axios.defaults.headers.common['Authorization'] = result.data.access_token;
          commit('setUser', result.data);
        }
        // return result.data;
      } catch (e) {
        commit('setError', e.response.data.message);
        throw e;
      }
    }

    // logout({commit}){
    //     console.log('lo')
    //     return new Promise((resolve) => {
    //       commit('logout')
    //       commit('clearError')
    //       localStorage.removeItem('ui-t')
    //       delete axios.defaults.headers.common['Authorization']
    //       resolve()
    //     })
    // }
  }
};
